export default __webpack_public_path__ + "a63cdcd921ae2a543cd77c0b5d6b7ec3.png";